interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  ogImage?: string;
  noIndex?: boolean;
  schema?: object | object[];
}

const siteUrl = import.meta.env.VITE_SITE_URL || '';

export default function SEOHead({
  title,
  description,
  keywords,
  canonical,
  ogTitle,
  ogDescription,
  ogType = 'website',
  ogImage,
  noIndex = false,
  schema,
}: SEOHeadProps) {
  const today = new Date().toISOString().split('T')[0];
  const schemaArray = schema
    ? Array.isArray(schema)
      ? schema
      : [schema]
    : [];
  const resolvedCanonical = canonical ? `${siteUrl}${canonical}` : undefined;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {resolvedCanonical && <link rel="canonical" href={resolvedCanonical} />}
      <meta name="last-modified" content={today} />
      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      <meta property="og:title" content={ogTitle ?? title} />
      <meta property="og:description" content={ogDescription ?? description} />
      <meta property="og:type" content={ogType} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      {resolvedCanonical && <meta property="og:url" content={resolvedCanonical} />}
      {schemaArray.map((s, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(s) }}
        />
      ))}
    </>
  );
}
